module.exports = __webpack_public_path__ + "static/media/coursera.cbc990c6.png";